<template>
  <div class="room-extend-menu-section-contents">
    <RoomChatForm type="record" :data-record-id="record.recordId"
      v-for="record in recordList"
      :key="record.recordId"
      :section="section"
      :item="itemObj(record)"
      @onClickDownload="handleClickDownloadRecord(record)"
      @onClickDelete="onClickDelete"
    />
  </div>  
</template>

<script>

import {mapActions, mapGetters, mapMutations} from "vuex";
import RoomChatForm from '@/components/Room/Chat/RoomChatForm'
import moment from "moment";

export default {
  name: 'RoomRecord',
  components: {
    RoomChatForm
  },
  props: {
    section: {
      type: String,
      default: 'record',
    },
    record: Object,
    newWindow:{
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters('record', [
      'recordFileList',
      'recordState',
    ]),
    ...mapGetters('room', [
      'room'
    ]),
    isChatSection(){
      return this.section == 'chat'
    },
    recordList(){
      return !this.record ? this.recordFileList : [this.record]
    },
    itemObj(){
      return record => {
        return {
          ...record,
          title: this.getRecordFileTitle(record),
          filesize: this.getFormattedSize(record.filesize),
          duration: this.getFormattedDuration(record.duration),
          expireDate: this.getFormedDate(record.expireDate),
          receiveDate: !this.isChatSection && this.getFormedDate(record.endDate),
          nickname: this.$t('extendMenu.record.file'),
          isFile: true,
        }
      }
    },
    getFormedDate() {
      return date => {
        return moment(date).format('YYYY-MM-DD');
      }
    },
    getFormattedDuration() {
      return duration => {
        if(duration < 1) {
          duration = 1;
        }
        // if(duration < 60){
        //   return moment.utc(0).seconds(duration).format('s초')
        // } else if(duration < 3600) {
        //   return moment.utc(0).seconds(duration).format('m분 s초');
        // } else {
        return moment.utc(0).seconds(duration).format('HH:mm:ss');
        // }
      }
    },
    getFormattedSize() {
      return filesize => {
        let size = Math.round(filesize/(1024*1024)*100) / 100
        return `${size}MB`;
      }
    },
    getRecordFileTitle() {
      return recordFile => {
        return `${this.getFileDateForm(recordFile.regDate)}~${this.getFileDateForm(recordFile.endDate)}`;
      }
    },
    getFileDateForm() {
      return date => {
        return moment(date).format('HH:mm:ss');
      }
    },
  },
  methods: {
    ...mapActions('record', [
      'deleteRecordFile',
      'getRecordFileUrl',
    ]),
    ...mapMutations('record', [
      'UPDATE_RECORD_DOWNLOAD_PROGRESS',
      'REMOVE_RECORD_FILE_INSTANCE',
    ]),
    // async handleClickPlayRecord(recordFile) {
    //   let url = await this.getFileUrl(recordFile);
    //   this.runUrlTag({url, recordFile});
    // },
    // async getFileUrl(recordFile){
    //   if(!recordFile.url) {
    //     recordFile.url = await this.getRecordFileUrl(recordFile);
    //   }
    //   return recordFile.url;
    // },
    async handleClickDownloadRecord(recordFile) {
      if(recordFile._download){
          console.log('download already :', recordFile, recordFile._download);
          return;
      }
      try{
          recordFile._download = new Date();
          let blobUrl = await this.getFileBlobUrl(recordFile);
          this.runUrlTag({url: blobUrl, recordFile});
      }finally{
          delete recordFile._download;
      }
    },
    filenameFormat(recordFile) {
      let regDate = moment(recordFile.regDate).format('YYYYMMDD__HH_mm_ss');
      let fileExtension = recordFile.convertMp4 ? 'mp4' : 'webm';
      let roomTitle = this.room.roomTitle
          || recordFile.roomUrlId
          || recordFile.roomId;

      return `${roomTitle}__${regDate}.${fileExtension}`;
    },
    runUrlTag({url, recordFile}){
      const a = document.createElement('a');
      try{
        a.href = url;
        a.download = this.filenameFormat(recordFile);
        a.target= '_blank'
        document.body.append(a);
        a.click();
      }finally{
        window.URL.revokeObjectURL(url);
        a.remove();
      }
    },
    async getFileBlobUrl(recordFile){
      this.UPDATE_RECORD_DOWNLOAD_PROGRESS({recordFile, progress: 0, downloadState: 'preparing'});
      
      try {
        let url = await this.getRecordFileUrl(recordFile);
        let res = await fetch(url);

        const reader = res.body.getReader();
        const contentLength = res.headers.get('Content-Length');

        let receivedLength = 0;
        let chunks = [];
        let done = false;

        this.UPDATE_RECORD_DOWNLOAD_PROGRESS({recordFile, downloadState: 'downloading'});
        while (!done) {
          const {done, value = 0} = await reader.read();

          if (done) {
            break;
          }

          chunks.push(value);
          receivedLength += value.length;

          this.UPDATE_RECORD_DOWNLOAD_PROGRESS({recordFile, progress: Math.ceil(receivedLength / contentLength * 100)});
        }

        let Uint8Chunks = new Uint8Array(receivedLength), position = 0;
        for (let chunk of chunks) {
          Uint8Chunks.set(chunk, position);
          position += chunk.length;
        }

        let blobUrl = URL.createObjectURL(new Blob([Uint8Chunks]));
        return blobUrl;
      } catch (e) {
        this.$alert({
          text: this.$t('extendMenu.record.downloadError'),
          onlyOk: true
        });
        throw e;
      }finally {
        this.UPDATE_RECORD_DOWNLOAD_PROGRESS({recordFile, downloadState: 'completed'});
      }
    },
    async onClickDelete(recordFile){
      try {
        await this.deleteRecordFile({ recordFile });

        this.newWindow
          ? this.$parent.$parent.$parent.$parent.$refs.roomExtendMenu.$refs.chat.removeRecordChatHistory(recordFile)
          : this.$parent.$parent.$refs.chat.removeRecordChatHistory(recordFile);

      } catch (error) {
        console.error(error)
      }
    }
  },
}
</script>

